import { FRONTEND_VERSION } from '../util/constants.js'

export default function VersionPage(props) {
    return FRONTEND_VERSION
}
